import { getValidToken } from "../../utils/getValidToken";

export async function getData(url) {
  try {
  const token = await getValidToken();

    const response = await fetch(url, {
      method: "GET",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        
            // 'X-API-Key': 'T3l3trelSeXAnLtxHoPTAUK7W1vqblC1zGbHnk1IJzI'
      }

    });


    if (!response.ok) {
      let responseBody = null;
      try {
        responseBody = await response.json();
      } catch {
        responseBody = null;
      }

      const responseMessage =
        responseBody?.message ??
        responseBody?.detail ??
        responseBody?.error ??
        responseBody?.errors;
      const error = new Error(
        responseMessage
          ? String(responseMessage)
          : `HTTP error! Status: ${response.status}`,
      );
      error.status = response.status;
      error.responseBody = responseBody;
      throw error;
    }

    return await response.json();
  } catch (error) {
    console.error("Fetching failed:", error.message);
    throw error;
  }
}

